import { render } from "./Word.vue?vue&type=template&id=85764d16"
import script from "./Word.vue?vue&type=script&lang=js"
export * from "./Word.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/SignSentence/SignSentence/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__